define('bootstraper',[
	"bootstrap",
	"application",
	"modules",
	"jquery.jssor",
	"pushmenu",
	"bootstrap.carousel",
	"bootstrap.collapse.toggleblocker",
	"bootstrap.popover",
	"modernizr"
],
	function () {
		"use strict";

		angular.bootstrap(document, ["App"]);

	});
